<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    this.$store.dispatch('deleteBasicInfo')
    this.$store.dispatch('getBasicInfo')
  }
}
</script>

<style>
.color-blue{
  color:rgb(30, 80, 174) !important;
}
.color-red{
  color:rgb(216, 27, 67) !important;
}
.color-gary{
  color:#666;
}
.font-normal{
  font-weight: normal;
}
.text-block{
  font-size: 1rem;
  line-height: 2rem;
  margin:0;
  padding: 0;
  text-indent: 2rem;
  text-align: left;
  min-height: 2rem;
}
.ell2 {
  display: block;
  display: -webkit-box;
  max-width: 100%;
  margin: 0 auto;
  height: 2.5rem;
  font-size: 1rem;
  line-height: 1.3rem;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ell4 {
  display: block;
  display: -webkit-box;
  max-width: 100%;
  margin: 0 auto;
  height: 5.2rem;
  font-size: 1rem;
  line-height: 1.3rem;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.img-br-50{
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue